/* eslint-disable no-empty */
const SSO_HINT_KEY = 'sso_hint'
const SSO_HINT_VERSION = 1
const SSO_HINT_TTL_MS = 30 * 24 * 60 * 60 * 1000
const SSO_PLACEHOLDER_LOCAL_PART = 'user'

type SsoHint = {
  v: typeof SSO_HINT_VERSION
  domain: string
  expiresAt: number
}

const getDomainFromEmail = (email: string) => {
  const separatorIndex = email.lastIndexOf('@')

  if (separatorIndex <= 0 || separatorIndex === email.length - 1) {
    return null
  }

  return email.slice(separatorIndex + 1).toLowerCase()
}

const isValidHint = (value: unknown): value is SsoHint => {
  if (typeof value !== 'object' || value === null) {
    return false
  }

  const { v, domain, expiresAt } = value as Record<string, unknown>

  return (
    v === SSO_HINT_VERSION &&
    typeof domain === 'string' &&
    domain.length > 0 &&
    typeof expiresAt === 'number' &&
    expiresAt > Date.now()
  )
}

export const removeSsoHint = () => {
  try {
    localStorage.removeItem(SSO_HINT_KEY)
  } catch {}
}

export const setSsoHint = (email: string) => {
  const domain = getDomainFromEmail(email)

  if (!domain) {
    return
  }

  const hint: SsoHint = {
    v: SSO_HINT_VERSION,
    domain,
    expiresAt: Date.now() + SSO_HINT_TTL_MS
  }

  try {
    localStorage.setItem(SSO_HINT_KEY, JSON.stringify(hint))
  } catch {}
}

export const getSsoHintDomain = () => {
  try {
    const stored = localStorage.getItem(SSO_HINT_KEY)

    if (!stored) {
      return null
    }

    const parsed = JSON.parse(stored)

    if (!isValidHint(parsed)) {
      removeSsoHint()

      return null
    }

    return parsed.domain
  } catch {
    removeSsoHint()

    return null
  }
}

export const ssoLoginEmailForDomain = (domain: string) => `${SSO_PLACEHOLDER_LOCAL_PART}@${domain}`
